<template>
  <div class="basicInfo">
    <div class="title"> <span></span> {{ title }} </div>
    <el-divider></el-divider>
    <div class="title"> <span></span> 基本信息 </div>
    <SiruiSearch
      ref="formItem"
      :query="baseFormData"
      :columns="fromColumns"
      :isQueryPanel="false"
      :isDisabledForm="true"
    >
    </SiruiSearch>
    <div class="title"> <span></span> 附件上传 </div>
    <IEUploadFileType
      ref="upload"
      :tableData="fromData.attachmentList || []"
      :isShowDownBtn="true"
      dictType="PROJECT_INITIATION_FILETYPE_NO_CK"
    />
  </div>
</template>
<script>
  import { baseFromColumns } from './basicInfo.js';
  import API from '@/api/dataBase';
  import companyApi from '@/api/masterData/company.js';
  import { mapNumToString } from '@/utils';
  export default {
    name: 'basicInfo',
    props: {
      // companyList1: {
      //   type: Array,
      //   default: () => [],
      // },
      // departmentList: {
      //   type: Array,
      //   default: () => [],
      // },
      fromData: {
        type: Object,
        default: () => {},
      },
      title: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        companyList1: [], // 平台公司
        departmentList: [],
        baseFormData: {
          projectInitiationNo: '123',
          projectInitiationCreateDate: '333',
          businessType: '444',
          businessTypeName: '555',
          projectName: '666',
          projectAddress: '',
          indication: '',
          platformtCompany: [],
          platformtCompanyName: [],
          applyDepartmentNo: '',
          applyDepartmentName: '',
          subjectMatter: '',
          subjectMatterName: '',
          supplierNo: [],
          supplierName: [],
          customerNo: [],
          customerName: [],
          chargePersonNo: '',
          chargePersonName: '',
          declareDate: '',
          projectAccountingPeriod: '',
          projectUsageQuotaWan: '',
          projectReceivableQuotaWan: '',
          expenseBudget: '',
          projectIncomePoint: '',
          operatingRevenueTarget: '',
          profitTarget: '',
          projectNetProfitRate: '',
          grossProfitRate: '',
          deliveryQuantity: '',
          advanceAmount: '',
          // stampDuty: '',
          // travelExpense: '',
          // taxRate: '',
          costPrediction: '',
          costOfFunds: '',
          taxCost: '',
          sellingExpenses: '',
          projectMonthlyReturnRate: '',
          effectiveDateOfYield: '',
          upstreamSettlementAdjustment: '',
          upstreamSettlementAdjustmentValue: '',
          serviceChainRestriction: '',
          paymentMethod: '',
          paymentMethodName: '',
          remark: '',
          approveDate: '',
          attachmentList: [],
        },
      };
    },
    computed: {
      fromColumns() {
        return baseFromColumns(this);
      },
    },
    mounted() {
      this._getCompanyApi1();
    },
    methods: {
      // 平台公司
      async _getCompanyApi1() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const { data } = await this.$axios.post(API.GET_PERSON_API, params);
        if (data.code === 0) {
          this.companyList1 =
            data.data.personCompanyInfo.map((item) => {
              return {
                label: item.personCompanyName,
                value: item.personCompanyCode,
              };
            }) || [];
        } else {
          console.error('获取公司失败');
        }
      },
      // 根据平台公司code获取全部的部门
      async _getDepartment(companyCodeList) {
        const { data } = await this.$axios.post(
          companyApi.GET_COMPANY_INFO_BY_CODE,
          companyCodeList
        );
        if (data.code == 0) {
          // departmentList
          console.log(data);
          this.departmentList = data.data.map((item) => {
            return {
              value: item.createDepartmentCode,
              label: item.concatCompanyName,
            };
          });
        } else {
          console.error('根据公司code获取部门失败');
        }
      },
    },
    watch: {
      fromData: {
        handler(value) {
          console.log('这个值是', value);
          const {
            platformtCompanyName,
            platformtCompany,
            supplierName,
            supplierNo,
            customerNo,
            customerName,
          } = value;
          this.baseFormData = {
            ...value,
            ...mapNumToString(value),
            platformtCompanyName: platformtCompany.split(','),
            platformtCompany: platformtCompanyName.split(','),
            supplierName: supplierName.split(','),
            supplierNo: supplierNo.split(','),
            customerName: customerName.split(','),
            customerNo: customerNo.split(','),
          };
          this._getDepartment(platformtCompany.split(','));
        },
        immediate: true,
        deep: true,
      },
    },
  };</script
><style>
  .basicInfo {
    background-color: white;
    padding: 15px;
    margin-bottom: 15px;
  }
  .title {
    font-size: 16px;
  }
</style>
